export default {
      id: "company-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#company",
      toString: function () {
        return this.url;
      }
    }